import { render, staticRenderFns } from "./AppointmentList.vue?vue&type=template&id=657136c2&scoped=true"
import script from "./AppointmentList.vue?vue&type=script&lang=js"
export * from "./AppointmentList.vue?vue&type=script&lang=js"
import style0 from "./AppointmentList.vue?vue&type=style&index=0&id=657136c2&prod&lang=scss&scoped=true"
import style1 from "./AppointmentList.vue?vue&type=style&index=1&id=657136c2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "657136c2",
  null
  
)

export default component.exports